module.exports = __webpack_public_path__ + "img/3_en.37789d4a.webp";